import styled from 'styled-components';

export const SocialGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const SocialBtn = styled.button`
  width: 100%;
  height: 48px;
  border: 1.5px solid #e5e7eb;
  border-radius: 12px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 0;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover:not(:disabled) {
    background: #f9fafb;
    border-color: #d1d5db;
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

export const BtnIcon = styled.span`
  position: absolute;
  right: 16px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

export const BtnContent = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0 44px;
`;

export const BtnPrefix = styled.span`
  color: #6b7280;
  font-weight: 400;
  white-space: nowrap;
`;

export const BtnBrand = styled.strong`
  color: ${({ color }) => color};
  font-weight: 700;
  margin-left: 4px;
  white-space: nowrap;
`;

export const GoogleBtnWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 48px;
  border: 1.5px solid #e5e7eb;
  border-radius: 12px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: #f9fafb;
    border-color: #d1d5db;
  }

  ${BtnContent}, ${BtnIcon} {
    pointer-events: none;
  }
`;

export const GoogleLoginOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 2;
  overflow: hidden;
  border-radius: 12px;
  opacity: 0.01;
  cursor: pointer;

  > div {
    width: 100% !important;
    height: 100% !important;
  }

  .S9gUrf-YoZ4jf,
  .S9gUrf-YoZ4jf > div {
    width: 100% !important;
    height: 100% !important;
  }

  iframe {
    width: 100% !important;
    height: 100% !important;
    min-height: 48px !important;
    margin: 0 !important;
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    cursor: pointer !important;
  }
`;
